'use client';

import {signout} from '@/app/(auth)/signout/actions';
import LoadingButton from '@/components/loadingButton/LoadingButton';
import {Sparkles} from 'lucide-react';
import {useState} from 'react';

type HeaderAuthedActionsProps = {
  points?: number;
};

export default function HeaderAuthedActions({points}: HeaderAuthedActionsProps) {
  const [loading, setLoading] = useState(false);
  const hasPoints = points !== undefined;

  const handleSignOut = async () => {
    setLoading(true);
    await signout({});
    setLoading(false);
  };

  return (
    <div className="header-nav flex items-center justify-end gap-4 lg:flex-1">
      {hasPoints && (
        <div className="flex items-center gap-1 font-bold">
          <Sparkles />
          <span className="max-w-min sm:min-w-max">{points.toLocaleString()} points</span>
        </div>
      )}
      <LoadingButton
        className="hidden lg:inline-flex"
        loading={loading}
        onClick={() => void handleSignOut()}
        variant="outline"
      >
        Sign Out
      </LoadingButton>
    </div>
  );
}
